import React, { useEffect } from 'react'
import CenterStage from '../../../Components/CenterStage/CenterStage';
import SectionHeader from '../../../Components/SectionHeader/SectionHeader';
import ImageText from '../../../Components/ImageText/ImageText';
import imgPlaceholder from '../../../assets/TimelinePlaceholder.png'
import NumberGrid from '../../../Components/NumberGrid/NumberGrid';
import ThreeDImageCarousel from '../../../Components/CircleCarousel/CircleCarousel';
import { Button } from 'react-bootstrap';
import Promoter from '../../../Components/Promoter/Promoter';
import imgProduction from '../../../assets/Branch/Production.jpg'
import imgHANSA_FLEX_BRANCH_SERBIA_NIS from '../../../assets/Journey/HANSA_FLEX_BRANCH_SERBIA_NIS.webp'
import imgNIS1 from '../../../assets/Branch/NIS/NIS1.jpg';
import imgNIS2 from '../../../assets/Branch/NIS/NIS2.jpg';
import imgNIS3 from '../../../assets/Branch/NIS/NIS3.jpg';
import imgNIS4 from '../../../assets/Branch/NIS/NIS4.jpg';
import imgNIS5 from '../../../assets/Branch/NIS/NIS5.jpg';
import imgProduction_1 from '../../../assets/Branch/Production/Production_1.jpg';
import imgProduction_2 from '../../../assets/Branch/Production/Production_2.jpg';
import imgProduction_3 from '../../../assets/Branch/Production/Production_3.jpg';
const Branch3 = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const carouselData = [
        {
            image: imgProduction_1,
        },
        {
            image: imgProduction_2,
        },
        {
            image: imgProduction_3,
        },

    ]

    const carouselData2 = [
        {
            image: imgNIS1,
        },
        {
            image: imgNIS2,
        },
        {
            image: imgNIS3,
        },
    ]
    return (
        <div>
            <CenterStage imageSrc={imgHANSA_FLEX_BRANCH_SERBIA_NIS} title={"Welcome to HANSA-FLEX Niš"} paragraph={"Founded in 2013, on the entrance to the city, next to the airport and accross the legendary restoraunt MRAK, HANSA-FLEX Niš has quickly gained the confidence of the wide veriaty of customers, from construction sector, maintenance, production where we are OEM supplier, mines, especially in the region of Bor, where we supply all the leading companies who are doing drilling for the exploration purposes, where we have installed several containers for fabrication of hydraulic hoses.Beside Niš, the branch covers the large region from Negotin and Žagubica on the North, accross Kuršumlija to administrative line with Kosovo and borders with Norhtern Macedonia and Bulgaria."}
                buttonName={"Contact us"} buttonLink={"/contact-us"}
            />
            <ThreeDImageCarousel items={carouselData} />
            <div className="text-center div-gray">
                <SectionHeader
                    title={"📞 At Your Service – We're Just a Call Away!"}
                    subtitle={"We’re here when you need us most. Whether it’s regular maintenance or an emergency situation, our team is available around the clock to provide expert hydraulic service and support."}
                />
                <Button variant="danger" className="ImageText-button m-2" href='/contact-us'>{("24h SERVICE")}</Button>
                <Button variant="danger" className="ImageText-button" href='/contact-us'>{("FLEXXPRESS 24h")}</Button>
                <br /><br /><br />
            </div>

            <ThreeDImageCarousel items={carouselData2} />

        </div>
    )
}

export default Branch3